import { textAlignmentConst } from '@klarna/designtokens';
export var defaultTextAlignments = {
  'text-alignment/start': textAlignmentConst('start'),
  'text-alignment/center': textAlignmentConst('center'),
  'text-alignment/end': textAlignmentConst('end')
};
//# sourceMappingURL=index.js.map